import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { getDataFromServer } from '../shared/utilities'
import EventsCalendar from '../components/EventsCalendar'
import LayoutListView from '../components/LayoutListView'

const Events = ({ location }) => {
  const configID = '2YXlfab8d6bCai7MaIF5cu'
  const [allEvents, setAllEvents] = useState([])

  useEffect(() => {
    const endpointEvents = 'https://www.missionone.com.au/api/events/'
    const token = process.env.GATSBY_MISSION_ONE_API_TOKEN

    if (!token) console.error('No MissionOne Token - fetch will fail')

    function getTime(time) {
      const arr = time.split('-')
      const day = +arr[0]
      const month = +arr[1] - 1
      const year = +arr[2]
      return new Date(year, month, day)
    }

    getDataFromServer(endpointEvents, token, false).then(event => {
      const events = event.sort((a, b) => (getTime(a.startDate) > getTime(b.startDate) ? 1 : -1))
      // @TODO - temporary hack to remove test
      const removed = events.filter(item => item.id !== 427)
      setAllEvents(removed)
    })
  }, [])

  return (
    <LayoutListView path={location.pathname} configID={configID}>
      <EventsCalendar data={allEvents} title="Events by Month" />
    </LayoutListView>
  )
}

export default Events

Events.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  }).isRequired
}
